














































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { PostProductDetail, GetProductDetail } from "@/request/system";
@Component({})
export default class ProductDetail extends Vue {
  @Prop()
  private product: any;
  private get p() {
    return this.product;
  }
  private set p(val) {
    this.$emit("update:product", val);
  }
  private goBack() {
    this.$emit("close");
  }
  /**
   * @description 选择全部
   */
  private selectAll(val, key) {
    if (val) {
      this.p[key]["choice"] = true;
      Object.keys(this.p[key]["values"]).forEach((item: any) => {
        this.p[key]["values"][item] = true;
      });
    } else {
      this.p[key]["choice"] = false;
      Object.keys(this.p[key]["values"]).forEach((item: any) => {
        this.p[key]["values"][item] = false;
      });
    }
  }
  /**
   * @description 选择某个
   */
  private selectOne(val, key) {
    if (val) {
      this.p[key]["choice"] = true;
    } else {
      this.p[key]["choice"] = false;
      Object.keys(this.p[key]["values"]).forEach((item: any) => {
        if (this.p[key]["values"][item]) {
          this.p[key]["choice"] = true;
        }
      });
    }
  }
  /**
   * @description 保存
   */
  private save() {
    if (!this.p["名称"]) {
      this.$message.warning("产品名称不能为空");
      return;
    }
    if (!this.p["介绍"]) {
      this.$message.warning("产品介绍不能为空");
      return;
    }
    const params: any = _.cloneDeep(this.p);
    PostProductDetail(this, params).then((data: any) => {
      this.$message.warning("保存成功");
      this.$emit("close");
    });
  }
}
